import { useMemo } from 'react';
import { useCurrentSafe, useSafes } from 'store';
import { IClaimMultiSignWallet, IMultiSignWallet } from 'types';

export const isActivatedPro = (initialSafe: IMultiSignWallet, safes: IClaimMultiSignWallet[]) => {
  const currentSafe = (initialSafe.parrentId
    ? safes.find((safe) => safe._id === initialSafe.parrentId)
    : initialSafe) as unknown as IMultiSignWallet;
  if (!currentSafe) return false;

  return true;

  const now = Date.now();

  const endTime = currentSafe.actualSubscriptionEndTime
    ? new Date(currentSafe.actualSubscriptionEndTime).getTime()
    : 0;

  const startTime = currentSafe.actualSubscriptionStartTime
    ? new Date(currentSafe.actualSubscriptionStartTime).getTime()
    : 0;

  return endTime > now && endTime > startTime;
};

export const useIsProActivated = () => {
  const { currentSafe } = useCurrentSafe();
  const { safes } = useSafes();

  return useMemo(() => {
    if (!currentSafe) return false;

    return isActivatedPro(currentSafe, safes);
  }, [currentSafe, safes]);
};
